var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-aside',{attrs:{"width":'210px'}},[_c('el-menu',{attrs:{"default-openeds":_vm.openeds},on:{"select":_vm.handleNodeClick}},[_c('menu-tree',{attrs:{"menuData":_vm.menuList}})],1)],1),_c('el-main',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.innerHtml)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }